module.exports = __webpack_public_path__ + "media/icons/add-item@2x-a6e0ba82.png";